<template>
    <div>
        <div class="p-3">
            <route-filter @update-filter="updateFilter" />
        </div>
        <div class="ft-lsp-list-container" v-if="$store.getters.getLspSupplyList.length > 0">
            <div class="ft-overflow-auto pb-5 ft-bg-grey">
                <demand-detail-card  v-for="(demand, id) in $store.getters.getLspSupplyList" 
                :key="id" 
                :data="demand" 
                btnText="Quick Add"
                _type="supply"
                />
                <div v-if="$store.getters.getLspSupplyList.length" v-observe-visibility="loadMore"></div>
                <div style="text-align: center" v-if="showPageLoader">
                    <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
                </div>

            </div>
        </div>
        <div v-if="$store.getters.getLspSupplyList.length == 0 && !showPageLoader">
            <NoLoadsLsp route="lsp_app" type="supply_list"/>
        </div>
    </div>
</template>

<script>
import RouteFilter from '../components/RouteFilter.vue'
import DemandDetailCard from '../components/DemandDetailCard.vue'
import NoLoadsLsp from '../components/NoLoadsLsp.vue'
import axios from "axios";
const API_BASE_URL = process.env.VUE_APP_API_GATEWAY_BASE_URL

export default {
    components: {
        RouteFilter,
        DemandDetailCard,
        NoLoadsLsp
    },
    props: {
        data: [Array, Object]
    },
    data() {
        return {
            supplyList: [],
            showPageLoader: false,
            pagination: {
                total: 0,
                pageSize: 2,
                currentPageNo: 0,
                searchAfter: null
            },
            pageSize: 2,
            currentPage: 0,
            originPlaceID: "",
            destinationPlaceID: "",
            routes_list: {},
            enableFilter: true
        }
    },
    methods: {
        loadMore(isVisible) {
            if (isVisible && (this.supplyList.length < this.pagination.total)) {
                this.currentPage += 1;
                this.getSupplyList()
            }
        },
        async getSupplyList(isDefault = false) {
            this.showPageLoader = true
            try {
                const pageNo = isDefault ? 0 : this.currentPage;
                const filter = this.enableFilter ? this.generateEndpoint() : ""
                console.log(filter)
                const url = `${API_BASE_URL}/supply/list/?page_number=${pageNo}&page_size=${this.pageSize}` + filter
                const {data} = await axios.get(url)
                this.pagination = data.value.pagination
                const list = data.value.data
                if (list.length > 0) {
                    for (let i = 0; i < list.length; i++) {
                        list[i].required_no_of_trucks = list[i].vehicle_count
                        list[i].truck_type = list[i].vehicle_label
                    }
                    this.supplyList = isDefault ? list : [...this.supplyList, ...list]
                } else {
                    this.supplyList = []
                }
              
                this.$store.commit('updateLspSupplyList', this.supplyList)
            } catch (error) {
                console.log(error)
            }
            this.showPageLoader = false
        },
        updateFilter(data) {
            console.log(data)
            this.routes_list = data
            this.currentPage = 0
            this.getSupplyList(true)
        },
        generateEndpoint() {
            let endpoint = ""
            if (this.routes_list?.origin_place_id) {
                endpoint += `&origin=${this.routes_list.origin_place_id}`
            }

            if (this.routes_list.destination_place_id) {
                endpoint += `&destination=${this.routes_list.destination_place_id}`
            }
            return endpoint
        }
    },
    mounted() {
        this.getSupplyList();
    }
}
</script>

<style lang=scss>

</style>

